import { z } from "zod";
export const DTOForgeProjectArtifactRoom = z.object({
    id: z.string(),
});
export const DTOForgeProjectArtifactRoomResponse = z.object({
    room: DTOForgeProjectArtifactRoom,
});
